<template>
    <div class="search">
        <el-autocomplete 
        class="search-input"
        v-model="model"
        placeholder="请输入受益人"
        clearable
        :trigger-on-focus="false"
        :fetch-suggestions="fetchHistorySuggestion"
        :maxlength="50"
        >
            <div 
            v-if="item.type === 'group-title'"
            class="group-title"
            slot-scope="{ item }"
            @click.prevent.stop
            >
                {{item.value}}
            </div>

            <div 
            class="suggest-item" 
            slot-scope="{ item }"
            v-else-if="item.id"
            >   
            <el-tooltip class="item" effect="dark" :content="item.value" :disabled="contentShow(item.value)" placement="left">
                 <div class="value">{{ item.value }}</div>
            </el-tooltip>
            </div>
        </el-autocomplete>
    </div>
</template>

<script>

export default {
    props:{
        value: {
            type: [String, Object],
            default: () => ({})
        }
    },
    data() {
        return {
            questionVisible: false,
            currentName:'',//当前名称

            historyList: [],
            suggestList: [],

            selectObj:{}, //当前查询对象
        };
    },
    computed: {
        model: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    },
    methods: {

        /**
         * 模糊查询企业名称 返回推荐列表
         * @param {String} name 名称
         * @param {Function} cb 回调 
         */
        
        getSearchNow(name,cb) {
            var that = this;

            this.$ajax({
                type: "get",
                url: `${this.$store.state.api.webUrl}/msgpush/wordmatch`,
                data: {
                    word:name,
                },
                callback: function (data) {
                    that.suggestList = data || [];
                     cb&&cb()
                },
            });

            // cb && cb()
        },

        /**
         * 匹配输入建议
         */
        fetchHistorySuggestion(queryString, cb) {
            const that = this
            var results = []
            
            var resFun = function(){
                // 如果已输入则显示输入提示
                var res = that.suggestList.length > 0 ? [
                    ...that.suggestList.map(text => {
                        return {
                            value: text,
                            id: text,
                        };
                    })
                ] : [
                        {
                            type: 'group-title',
                            value: '无搜索结果',
                            disabled: true,
                        }
                ];


                results = res
                // 调用 callback 返回建议列表的数据
                cb(results);
            }

            that.getSearchNow(queryString,resFun);
            
        },

        /** 
         * 是否显示文字提示
         * @param {String} val 传入的文字
         * @param {Number} maxNum 字数临界值
        */
        contentShow(val,maxNum){
            const textLength = val.length;
            let num = maxNum || 13
            return textLength > num ? false : true
        },
    },
    mounted() {
        
    }
}
</script>

<style lang="scss" scoped>
    @import '@css/var.scss';
    .suggest-item {
        .value{
            text-overflow: ellipsis;
            overflow: hidden;
        }
    }

    
</style>